import { useEffect, useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    tel: '',
    message: ''
  });

  useEffect(() => {
    const hash = window.location.hash.replace('#', '');

    if (hash !== 'contact' && hash !== 'contact-form') return;

    window.requestAnimationFrame(() => {
      document.getElementById(hash)?.scrollIntoView({ block: 'start' });
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      access_key: 'a1ffc801-08fc-469a-867f-a5a70f70bb15',
      subject: 'サイトからお問い合わせがありました',
      from_name: 'NAGARA container',
      name: formData.name,
      email: formData.email,
      tel: formData.tel,
      message: formData.message,
    };

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (result.success) {
        alert('送信できました。お問い合わせありがとうございます。');
        setFormData({
          name: '',
          email: '',
          tel: '',
          message: ''
        });
      } else {
        alert('送信に失敗しました。時間をおいて再度お試しください。');
      }
    } catch (error) {
      console.error('送信エラー:', error);
      alert('送信に失敗しました。');
    }
  };

  return (
    <section className="section contact-section" id="contact">
      <div className="container">
        <div className="section-head reveal">
          <p className="section-label">CONTACT</p>
          <h2 className="section-title">お問い合わせ</h2>
          <p className="section-desc">
            コンテナの販売・設置・配送について、お気軽にご相談ください。
          </p>
        </div>
        <div className="contact-cta">
          <a
            href="https://lin.ee/ziXev4I"
            target="_blank"
            rel="noopener noreferrer"
            className="line-contact-btn"
          >
            <span>LINE</span>
            QUICK CONTACT
          </a>

          <p className="contact-note">
            お急ぎの方はLINEからもご相談いただけます。
          </p>
        </div>
        <div className="contact-wrap">
          <form id="contact-form" className="contact-form" onSubmit={handleSubmit}>
            <div className="form-field">
              <label>お名前</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="山田 太郎" required />
            </div>

            <div className="form-field">
              <label>メールアドレス</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="example@mail.com" required />
            </div>

            <div className="form-field">
              <label>電話番号</label>
              <input type="tel" name="tel" value={formData.tel} onChange={handleChange} placeholder="090-0000-0000" />
            </div>

            <div className="form-field">
              <label>お問い合わせ内容</label>
              <textarea name="message" value={formData.message} onChange={handleChange} rows="6" placeholder="お問い合わせ内容をご入力ください" required></textarea>
            </div>

            <button type="submit" className="submit-btn">
              無料で相談してみる
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
